import React,{useState} from 'react'
import Fade from 'react-reveal/Fade';
import Punjab from './Punjab'
import Karachi from './Karachi'
import Balochistan from './Balochistan';
import Khyber from './Khyber';

const Provinces = (props) => {

    const [data, setData] = useState(false)


    return (
        <>
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="province_heading">
                    <h1 className='pt-4'>{props.heading}</h1>
                    </div>
                </div>
            </div>
        </div>
        <Fade left>
        <div className="provinces">
            <div className="container">
                <div className="row">
                    <div className="col-md-3">
                        <div className='punjab' onClick={()=>setData("Punjab")} >
                        <h1>Punjab</h1>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className='sindh' onClick={()=>setData("Sindh")} >
                        <h1>Sindh</h1>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className='balochistan' onClick={()=>setData("Balochistan")}>
                        <h1>Balochistan</h1>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className='khyber' onClick={()=>setData("Khyber")}>
                        <h1>Khyber Pakhtunkhwa</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </Fade>
        {data===("Punjab") && <Punjab/>}
        {data===("Sindh") && <Karachi/>}
        {data===("Balochistan") && <Balochistan/>}
        {data===("Khyber") && <Khyber/>}

        </>
    )
}

export default Provinces